import React, { useRef } from 'react';
import useConstellationEngine from './useConstellationEngine';

const canvasStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  pointerEvents: 'none',
  zIndex: 0,
  background: 'transparent',
};

const counterWrapperStyle = {
  position: 'fixed',
  top: 16,
  right: 16,
  zIndex: 5,
  pointerEvents: 'none',
};

const counterStyle = {
  padding: '8px 12px',
  borderRadius: 12,
  background: 'rgba(10, 15, 28, 0.6)',
  color: '#ddecff',
  fontSize: 13,
  letterSpacing: '0.4px',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.35)',
  border: '1px solid rgba(125, 207, 255, 0.35)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
};

function TrafficConstellationsCanvas() {
  const canvasRef = useRef(null);
  const { guestCount, isDisabled } = useConstellationEngine(canvasRef);

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          ...canvasStyle,
          opacity: isDisabled ? 0 : 0.95,
        }}
        aria-hidden="true"
      />
      <div style={counterWrapperStyle} className="traffic-counter">
        <div style={counterStyle}>
          {guestCount} Visitors at the Galaxy Gate
        </div>
      </div>
    </>
  );
}

export default TrafficConstellationsCanvas;
